<div class="add-food-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="add-food-nav-bar box">
    <div class="add-food-nav-bar-title">اضافه کردن غذا</div>
    <div class="add-food-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="add-food-top box">
    <div class="search-box">
      <img src="assets/general/search-blue.svg" />
      <input
        type="text"
        id="addFoodInput"
        [(ngModel)]="searchText"
        placeholder="جستجو"
        autocomplete="false"
        autofocus
        (ngModelChange)="search($event)"
      />
    </div>
  </div>
  <div class="result-box">
    <div
      class=""
      *ngIf="
        histories &&
        histories.length > 0 &&
        !isEmpty &&
        searchedFoods.length == 0
      "
    >
      <p
        style="
          padding-right: 16px;
          position: absolute;
          top: 130px;
          color: rgb(0, 0, 0);
          font-size: 16px;
          font-family: Vazir-Medium !important;
          font-weight: 500;
          text-align: right;
          letter-spacing: 0px;
        "
      >
        جستجو اخیر
      </p>
      <div style="margin-top: 30px">
        <div class="result-item" *ngFor="let food of histories; let i = index">
          <p (click)="foodDetail(food._id)">{{ food.name }}</p>
          <img
            (click)="removeFoodLog(food)"
            src="assets/general/cross-blue.svg"
          />
        </div>
      </div>
    </div>
    <div *ngIf="searchedFoods.length !== 0">
      <div
        class="result-item"
        (click)="foodDetail(food._id)"
        *ngFor="let food of searchedFoods; let i = index"
      >
        <p>{{ food.name }}</p>
        <img src="assets/general/left-blue.svg" />
      </div>
    </div>
  </div>
  <p
    *ngIf="isEmpty"
    style="
      text-align: center;
      color: rgb(102, 102, 102);
      position: absolute;
      top: 20%;
      width: 100%;
    "
  >
    غذای مورد نظر پیدا نشد .
  </p>
</div>
